import './Footer.css'
import React from 'react';
import { FormControl, InputGroup, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div>
            <div className="footer-container">
                <div>

                    <h1>Udvash Center</h1>
                    <div className="footer-details">
                        <div>
                            <p>Address:Dhaka-1361,Bangladesh</p>
                            <p>phone:01749393853</p>
                            <p>Fax:13235551234</p>

                            <div className="social-icon">
                                <i class="fab fa-instagram"></i>
                                <i class="fab fa-twitter"></i>
                                <i class="fab fa-facebook"></i>
                                <i class="fab fa-linkedin-in"></i>
                            </div>
                        </div>

                    </div>

                </div>
                <div className="newsletter">
                    <h2>Subscribe</h2>
                    <InputGroup className="mb-3 w-50 mx-auto">
                        <FormControl
                            placeholder="Email"

                        />
                        <Button id="button-addon2">
                            Subscribe
                        </Button>
                    </InputGroup>
                </div>
            </div>
        </div>
    );
};

export default Footer;